import config from '@/config';
import fetchWrapper from '@/services/fetchWrapper.service';

export async function getArtworkQr(artworkId) {
  if (!artworkId) {
    throw new Error('Artwork id is required');
  }

  const { response, data } = await fetchWrapper.get(
    `${config.apis.api.url}/artwork/${artworkId}/qr-code/`,
    {
      injectToken: true,
    }
  );

  if (response.status === 404) {
    return null;
  }

  if (!response.ok) {
    throw new Error(data?.error_message || data?.error || 'Unable to load artwork QR code');
  }

  return data;
}

export async function ensureArtworkQr(artworkId) {
  if (!artworkId) {
    throw new Error('Artwork id is required');
  }

  const { response, data } = await fetchWrapper.post(
    `${config.apis.api.url}/artwork/${artworkId}/qr-code/`,
    {
      injectToken: true,
      body: {},
    }
  );

  if (!response.ok) {
    throw new Error(data?.error_message || data?.error || 'Unable to generate artwork QR code');
  }

  return data;
}
